// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div a[data-v-09332a72] {\n  color: blue;\n}\ndiv a[data-v-09332a72]:hover {\n    color: red;\n}\n", ""]);
// Exports
module.exports = exports;
